import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme';
import MainPage from './pages/MainPage';
import WelcomePage from './pages/WelcomePage';
import ToolsPage from './pages/ToolsPage';
import SessionAccessPage from './pages/SessionAccessPage';
import SessionToolsPage from './pages/SessionToolsPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AiRecordPage from './pages/AiRecordPage';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/tools" element={<ToolsPage />} />
          <Route path="/ai-record" element={<AiRecordPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/tools/admin" element={<AdminDashboardPage />} />
          <Route path="/tools/:sessionId" element={<SessionAccessPage />} />
          <Route path="/tools/:sessionId/:userId" element={<SessionToolsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
